import { render, staticRenderFns } from "./ParticipantProfile.vue?vue&type=template&id=e604a988&"
import script from "./ParticipantProfile.vue?vue&type=script&lang=js&"
export * from "./ParticipantProfile.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports